/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { Button, IButtonProps } from "../../core";

import "./FieldListItemAction.scss";

export interface IFieldListItemActionProps extends IButtonProps {
	children?: React.ReactNode;
	className?: string;
}

export const FieldListItemAction: React.FC<IFieldListItemActionProps> = ({
	className,
	children,
	...props
}) => {
	const baseClass = BEM("edt-field-list-item-action");

	if (className) {
		baseClass.add(className);
	}

	return (
		<Button className={baseClass.toClassName()} {...props}>
			{children}
		</Button>
	);
};
